import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    cart: {},
    error_cart: ''
  },
  getters: {
    cartExist: () => sessionStorage.getItem("cart") ? true : false
  },
  actions: {

    async add_to_cart({ dispatch, commit, rootState }, payload = []) {
      try {
        // Verificar se o usuário está logado
        if (!rootState.user.current_user?.id) {

          //if (window.innerWidth < 480) {
          toast.warning("Para adicionar itens ao carrinho, por favor, faça login.", {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
          //}

          /*dispatch("alert/set_alert", {
            alert_message: "<i class=\"fas fa-exclamation-triangle\"></i> Para adicionar itens ao carrinho, por favor, faça login.",
            type_message: 'alert-warning'
          }, { root: true });*/

          return Promise.reject(new Error("Usuário não está logado"));
        }

        let route_url = payload?.is_ad ? "/v1/add-ad-to-cart" : "/v1/add-to-cart";
        return api.post(route_url, payload)
          .then((res) => {
            if (res?.data?.error) {
              commit("ERROR_CART", res?.data?.error);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-warning'}, { root: true });

              //if (window.innerWidth < 480) {
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              //}
            } else {
              commit("SHOW_CART", res?.data?.result);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-success'}, { root: true });

              //if (window.innerWidth < 480) {
              toast.success(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              //}
            }
            return res?.data?.error
          })
          .catch((error) => {
            console.log(error)
            //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.warning(error, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CART", e);
        //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

        //if (window.innerWidth < 480) {
        toast.warning(e, {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        //}
      }
    },
    async get_cart({ commit }, guest) {
      try {
        api.get("/v1/active-cart/" + guest)
          .then((res) => {
            commit("SHOW_CART", res?.data);
          })
          .catch((error) => {
            commit("ERROR_CART", "Algo deu errado! Tente novamente mais tarde");
          })
          .finally(() => (
            // this.loading = false
            console.log('cart request end')
          ));
      } catch (e) {
        commit("ERROR_CART", "Algo deu errado! Tente novamente mais tarde");
        //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

        //if (window.innerWidth < 480) {
        toast.warning(e, {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        //}
      }
    },
    async destroy_cart({ dispatch, commit }, payload = []) {
      try {
        api.post("/v1/remove-from-cart/", payload)
          .then((res) => {
            if (res?.data?.error) {
              commit("ERROR_CART", res?.data?.error);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-warning'}, { root: true });

              //if (window.innerWidth < 480) {
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              //}
            } else {
              commit("SHOW_CART", res?.data?.result);
              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-success'}, { root: true });

              //if (window.innerWidth < 480) {
              toast.success(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              //}
            }
          })
          .catch((error) => {
            //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });
            commit("ERROR_CART", "Algo deu errado");

            //if (window.innerWidth < 480) {
            toast.warning(error, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_CART", e);
        //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

        //if (window.innerWidth < 480) {
        toast.warning(e, {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        //}
      }
    },
    show_warning({ commit }, message) {
      commit("ERROR_CART", message);
    },
    close_warning({ commit }) {
      commit("CLOSE_WARNING");
    },
    async update({ commit }, payload) {
      try {
        const res = await api.post("/v1/update-cart/", payload)
          .then((res) => {
            commit("SHOW_CART", res?.data?.result);
          })
          .catch((error) => {
            commit("ERROR_CART", "Algo deu errado! Tente novamente mais tarde");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_CART", "Algo deu errado! Tente novamente mais tarde");
        //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

        //if (window.innerWidth < 480) {
        toast.warning(e, {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        //}
      }
    },
    async save_order({ commit }, payload) {
      try {
        api.post("/v1/order/save-order", payload)
          .then((res) => {
            //alert('Pedido criado!, Precisa ser feito a reserva de produto, tela de sucesso, torre de email, integracao correios, gateway, entre outras coisas');
            if (res?.data?.error) {
              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
              return
            }
            sessionStorage.removeItem("cart")
            // setTimeout(() => {
            //   window.location = "/confirmed"
            // }, 1000)
          })
          .catch((error) => {
            const message = error?.response?.data?.message || error?.message || "Erro desconhecido";

            toast.error(message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        const message = error?.response?.data?.message || error?.message || "Erro desconhecido";

        toast.error(message, {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
       
      }
    },

    async save_store_shippiment({ commit }, payload) {
      try {
        await api.post("/v1/cart/save-store-shippiment", payload)
          .then((res) => {
            console.log(res)
            toast.success(res?.data?.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            commit("SHOW_CART", res?.data?.result);
          })
          .catch((error) => {
            commit("ERROR_CART", "Algo deu errado! Tente novamente mais tarde");
          })
          .finally(() => (
            console.log('')
          ));
      } catch (e) {
        console.log(e)

      }
    },
  },

  mutations: {

    ERROR_CART(state, message) {
      toast.warning(message, {
        type: 'default',
        theme: 'colored',
        hideProgressBar: true,
        dangerouslyHTMLString: true
      });
    },

    SHOW_CART(state, data) {
      state.cart = data
      if (data) {
        sessionStorage.setItem("cart", "existe")
      } else {
        sessionStorage.removeItem("cart")
      }




    },
    CLOSE_WARNING(state) {
      state.error_cart = ''
    },



  }
}